import { Set } from "immutable"
import * as React from "react"
import { CookieStatus } from "../../../Shared/utils/datalayer.mapping"
import { ApiResult, errorText, getNavigation, loadingText } from "../../custom_api/api"
import { NavigationItem } from "../../custom_models/drupal"
import { ChangeCookiesLink } from "./cookiebar"
import { pushFooterMembership } from "./datalayer"
import { LinkButton } from "./library/button"
import { Container, Row } from "./library/container"
import { Link } from "./library/link"
import { trackNewsletter } from "./library/tracking"

interface FooterProps {
  onCookieChange: (cookieStatus: CookieStatus) => void
}

interface FooterState {
  readonly secondaryItems: ApiResult<Set<NavigationItem>>
}

export class Footer extends React.Component<FooterProps, FooterState> {
  constructor(props: FooterProps) {
    super(props)

    this.state = {
      secondaryItems: "loading",
    }
  }

  componentWillMount() {
    getNavigation("footer-secondary").then(res => {
      if (res != "error" && res != "loading") {
        this.setState(s => ({ ...s, secondaryItems: Set(res) }))
      }
    })
  }

  render() {
    const p = this.props
    const s = this.state

    return (
      <footer lang="nl" id="a11y-footer" className="footer">
        <Container className="footer__top">
          <div className="footer__container">
            <Row>
              <div className="col-xs-12 col-md-4">
                <h2 className="title--m">Altijd op de hoogte</h2>
                <p className="footer__text">
                  Op de hoogte zijn van de laatste ontwikkelingen in jouw bibliotheek? In de nieuwsbrief ontvang je ook
                  boeken- en activiteitentips.
                </p>
                <LinkButton variant="white" arrow route="/nieuwsbrief" handle={() => trackNewsletter()}>
                  Aanmelden nieuwsbrief
                </LinkButton>
              </div>
              <div className="col-xs-12 col-md-4">
                <h2 className="title--m">Als lid kun je meer</h2>
                <p className="footer__text">
                  Kies uit een groot aantal boeken, e-books, luisterboeken, cursussen, activiteiten en meer. Als lid kun
                  je volop lezen, leren en lenen.
                </p>
                <LinkButton variant="white" arrow route="/lid-worden" handle={() => pushFooterMembership()}>
                  Lid worden
                </LinkButton>
              </div>
              <div className="col-xs-12 col-md-4">
                <div className="footer__social">
                  <div className="footer__inner">
                    <h2 className="title--m">Volg ons!</h2>
                    <p className="footer__text">
                      Via onze social media kanalen volg je wat er allemaal gebeurt in de bieb. Op ons YouTube kanaal
                      AanZet Live vind je al onze livestreams en online activiteiten.
                    </p>
                    <div className="footer__social__icons">
                      <Link className="social" url="http://www.twitter.com/biebaanzet" title="Twitter">
                        <span className="sr-text" id="social-twitter">
                          Ons Twitter account
                        </span>
                        <svg className="social__icon" width="2.4rem" height="2.4rem" aria-hidden="true">
                          <use xlinkHref="#icon--twitter" />
                        </svg>
                      </Link>
                      <Link className="social" url="http://www.facebook.com/biebaanzet" title="Facebook">
                        <span className="sr-text">Ons Facebook account</span>
                        <svg className="social__icon" width="2.4rem" height="2.4rem" aria-hidden="true">
                          <use xlinkHref="#icon--facebook" />
                        </svg>
                      </Link>
                      <Link className="social" url="https://www.instagram.com/biebaanzet/" title="Instagram">
                        <span className="sr-text">Ons Instagram account</span>
                        <svg className="social__icon" width="2.4rem" height="2.4rem" aria-hidden="true">
                          <use xlinkHref="#icon--instagram" />
                        </svg>
                      </Link>
                      <Link
                        className="social"
                        url="https://www.youtube.com/channel/UClmHUPZYWqwriCyKEBMt4Vg"
                        title="YouTube"
                      >
                        <span className="sr-text">Ons YouTube account</span>
                        <svg className="social__icon" width="2.4rem" height="2.4rem" aria-hidden="true">
                          <use xlinkHref="#icon--youtube" />
                        </svg>
                      </Link>
                      <Link className="social" url="https://www.linkedin.com/company/biebaanzet" title="LinkedIn">
                        <span className="sr-text">Ons LinkedIn account</span>
                        <svg className="social__icon" width="2.4rem" height="2.4rem" aria-hidden="true">
                          <use xlinkHref="#icon--linkedin" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </div>
        </Container>

        <div className="footer__bottom">
          <div className="footer__section--secondary">
            {" "}
            {/* ---- SECONDARY MENU ----- */}
            {s.secondaryItems == "loading" ? (
              loadingText
            ) : s.secondaryItems == "error" ? (
              errorText
            ) : (
              <nav className="footer__links" aria-label="Wettelijk">
                <Container>
                  <ul className="link__list">
                    {s.secondaryItems.map(link => (
                      <li key={`li-${link.key}`} className="link__item">
                        <Link
                          key={link.key}
                          url={link.external ? link.absolute : link.relative}
                          external={link.external}
                          handle={() => {
                            window.scrollTo({ top: 0, behavior: "smooth" })
                            const focusable = document.querySelectorAll('.menu__link');
                            (focusable[0] as HTMLElement).focus()
                          }}
                        >
                          {link.title}
                        </Link>
                      </li>
                    ))}
                    <li key={`li-reset`} className="link__item">
                      {ChangeCookiesLink({ onChange: p.onCookieChange })}
                    </li>
                  </ul>
                </Container>
              </nav>
            )}
          </div>
        </div>
      </footer>
    )
  }
}
